import styled from 'styled-components'
import logo from '../assets/continental.png'
import search from '../assets/search.png'
import burger from '../assets/burger.png'

function Header() {
  return (
    <HeaderContainer>
      <Logo src={ logo } alt={ logo } />
      <FindTires>FIND TIRES</FindTires>
      <Search src={ search } alt={ search } />
      <Burger src={ burger } alt={ burger } />
    </HeaderContainer>
  );
}

const HeaderContainer = styled.div`
    width: 90%;
    height: 80px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
`
const Logo = styled.img`
    height: 100%;
    width: auto;
`
const FindTires = styled.p`
    font-family: ContinentalMedium;
    font-weight: 500;
    letter-spacing: 0.093em;
    font-size: 12px;
`
const Search = styled.img`
    width: 17px;
    height: auto;
`
const Burger = styled.img`
    width: 23px;
    height: auto;
`

export default Header;
